export default __webpack_public_path__ + "static/media/web_traffic.36d8a947.jpg";